import { useEffect } from 'react';
import { cx } from '@/utils';
import { useFormContext } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';

import InfoBar from '@/components/common/Icons/InfoBar';

import type { InterfaceSelectedValue } from './ComboBoxWithLogo';
import ComboBoxWithLogoContext from './ComboBoxWithLogoContext';

export interface SelectOption {
  label: string | JSX.Element;
  value: any;
}
type Props = {
  currentId: string;
  options: SelectOption[];
  title?: string;
  onChange?: () => void;
  className?: string;
  placeholder?: string;
  optionsToFilter?: string[];
  disabled?: boolean;
  infoBoolean?: boolean;
  infoText?: string;
  // Permite pasar cualquier propiedad válida de react-select (menuPlacement, maxMenuHeight, etc.)
  selectProps?: Partial<InterfaceSelectedValue>;
};

const InputSelectContext = ({
  currentId,
  options,
  title,
  onChange,
  className,
  placeholder = 'Selecciona',
  optionsToFilter,
  disabled = false,
  infoBoolean = false,
  infoText = '',
  selectProps,
}: Props) => {
  const { watch, setValue } = useFormContext();

  const optionsToUse = optionsToFilter
    ? options.filter((option) => !optionsToFilter.includes(option.value))
    : options;

  const onChangeValue = () => {
    if (onChange) {
      onChange();
    }
  };

  useEffect(() => {
    const currentValue = watch(currentId);
    if (currentValue === undefined && optionsToUse && optionsToUse.length > 0) {
      setValue(currentId, optionsToUse[0].value, { shouldValidate: false });
    }
  }, [currentId, optionsToUse, setValue]);

  return (
    <div className={cx('flex-col', className)}>
      {title && (
        <label className="body-text1 flex items-center gap-2 text-tundora">
          {title}
          {infoBoolean && (
            <>
              <a
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${infoText}`}
                className="cursor-pointer"
              >
                <InfoBar />
              </a>
              <Tooltip
                className="font-workSans"
                style={{
                  backgroundColor: 'white',
                  cursor: 'pointer',
                  color: 'black',
                  borderRadius: '10px',
                  height: '50px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  border: '1px solid rgba(0, 0, 0, 0.1)',
                }}
                id="my-tooltip"
              />
            </>
          )}
        </label>
      )}

      <ComboBoxWithLogoContext
        options={optionsToUse as any}
        currentId={currentId}
        placeholder={placeholder}
        className="mt-2 rounded-md border-[1px] border-[#a3a3a3] outline-none"
        onChange={onChangeValue}
        isDisabled={disabled}
        {...selectProps}
      />
    </div>
  );
};

export default InputSelectContext;
